var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon",style:({ width: `${_vm.$attrs.size}px`, height: `${_vm.$attrs.size}px` })})
}
var staticRenderFns = []

export { render, staticRenderFns }